import ApiService from '@/services/api.service';
import getters from '@/store/global';

const state = {
    infoPages: {},
    errors: {}
};

getters['fetchInfoPages'] = function(state) { return state.infoPages }

const actions = {
    get(context, payload) {
        return ApiService
            .get('page/' + payload + '/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_INFO_PAGES', response.data);
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            })
    },
};

const mutations = {
    SET_INFO_PAGES(state, infoPages) {
        state.infoPages = infoPages;
        state.errors = {};
    },
    SET_ERROR(state, errors) {
        state.errors = errors;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
